angular.module('rjmNg.directives').directive 'figure', [
  "figureService"
  "figureEnums"
  "chartRenderQueue"
  "$timeout"
  (figureService, figureEnums, chartRenderQueue, $timeout) ->
    restrict: "A"
    replace: false
    priority: 150
    scope: true
    controller: [
      "$scope"
      "$element"
      "$attrs"
      "reportQueryType"
      ($scope, $element, $attrs, reportQueryType) ->
        @renderQueued = false

        # nearly identical to the chartDirective logic for renderChart.
        @renderFigure = (figure) ->
          # Clear any error classes which have been set previously
          $element.removeClass('figure-error-timeout')
          $element.removeClass('calculating')
          smallItem = $element.height() < 300 or $element.width() < 300
          $element.toggleClass('small', smallItem)

          unless figure?
            # No data on initial request. Show loading bar.
            $element.addClass('blocked loading')
            return

          if figure.error?
            $element.addClass('error')
            $element.removeClass('blocked loading')
            return

          if figure.warnings? and not figure.data?
            cacheInProgress = true for warning in figure.warnings when warning.code is figureEnums.WARNING_CODES.CACHE_IN_PROGRESS
            $element.toggleClass('calculating', cacheInProgress)
            $element.children().hide() # Only hide the highchart, don't remove it

          unless figure.data?
            return

          if figure.reportQueryType is reportQueryType.RJQL
            series = figureService.getSeriesDataFromFigure(figure)

            if series.length is 0 or series[0].data.length is 0
              # check to see if there is a cache process in progress
              cacheInProgress = false
              timedOut = false
              if figure.data.warnings?
                cacheInProgress = true for warning in figure.data.warnings when warning.code is figureEnums.WARNING_CODES.CACHE_IN_PROGRESS
                timedOut = true for warning in figure.data.warnings when warning.code is figureEnums.WARNING_CODES.IS_STALE

              $element.toggleClass('calculating', cacheInProgress)
              $element.toggleClass('figure-error-timeout', not cacheInProgress and timedOut)
              $element.toggleClass('noData', not cacheInProgress and not timedOut)
              $element.removeClass('blocked loading')
              $element.children().hide() # Only hide the highchart, don't remove it
              return

            figure = figureService.sortDataIfApplicable(figure)

          $element.children().show()

          if @renderQueued
            return
          @renderQueued = true
          # Chart Render queue code taken from chartDirective
          chartRenderQueue () =>
            @renderQueued = false
            unless figure.error? # In case there was an error before
              $element.removeClass('error')

            $element.removeClass "blocked loading"
            $element.removeClass "noData"

            # Add ready-to-render event broadcasting here.
            $scope.$broadcast("renderFigure", figure)

        @
    ]
    link: (scope, elem, attrs, controller) ->
      figureController = controller

      scope.$on "hideChartsAndFigures", (event) ->
        elem.hide()

      scope.$on "showChartsAndFigures", (event) ->
        elem.show()

      timeoutPromise = null
      scope.$watchCollection attrs.currentFigure, (figure, old) ->
        if figure?.data? or figure?.warnings? or figure?.error?
          _timeoutFunction = () ->
            figureController.renderFigure(figure)

          if timeoutPromise?
            $timeout.cancel(timeoutPromise)

          timeoutPromise = $timeout(_timeoutFunction, 0, false)

        unless figure?.data?
          figureController.renderFigure(null)

      figureController.renderFigure(null)

  ]
